import { render, staticRenderFns } from "./ApplicantDocuments.vue?vue&type=template&id=47ce63f2&"
import script from "./ApplicantDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicantDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantDocuments.vue?vue&type=style&index=0&id=47ce63f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports